import './skills.css';
import { ReactComponent as IconHtml } from './icons/html.svg';
import { ReactComponent as IconCss } from './icons/css.svg';
import { ReactComponent as IconJS } from './icons/js.svg';
import { ReactComponent as IconReact } from './icons/react.svg';
import { ReactComponent as IconPhp } from './icons/php.svg';
import { ReactComponent as IconSymfony } from './icons/symfony.svg';
import { ReactComponent as Iconbootstrap } from './icons/bootstrap.svg';
import { ReactComponent as IconTalend } from './icons/talend.svg';
import { ReactComponent as IconDocker } from './icons/docker.svg';
import { ReactComponent as IconGit } from './icons/git.svg';
import { ReactComponent as IconNode } from './icons/node.svg';
import { ReactComponent as IconSocket } from './icons/socket.svg';
import { ReactComponent as IconMaterial } from './icons/material.svg';
import { ReactComponent as IconGithub } from './icons/github.svg';
import { ReactComponent as IconGitlab } from './icons/gitlab.svg';
import { ReactComponent as IconSQL } from './icons/sql.svg';
import { ReactComponent as IconMysql } from './icons/mysql.svg';
import { ReactComponent as IconPostgres } from './icons/postgres.svg';
import { ReactComponent as IconCICD } from './icons/cicd.svg';
import { ReactComponent as IconLinux } from './icons/linux.svg';
import { ReactComponent as IconMailjet } from './icons/mailjet.svg';
import { ReactComponent as IconStripe } from './icons/stripe.svg';
import { ReactComponent as IconScaleway} from './icons/scaleway.svg';
import { ReactComponent as IconApiPlatform} from '../skills/icons/apiPlatform.svg';
import IconDust from '../skills/icons/dust.png';
import IconMake from '../skills/icons/make.png';
import IconDbdiagram from '../skills/icons/dbdiagram.png';

import {
    Container, Row, Col
} from 'reactstrap';

const Stack = () =>{
    const skillsContent = (
        <>
            <div className='col-skills fab'>
                <p><IconPhp width={25} style={{marginRight:'10px'}}/> PHP</p>
                <p><IconNode width={25} style={{marginRight:'10px'}}/> NODE JS</p>
            </div>
            <div className='col-skills fab'>
                <p><IconSymfony width={25} style={{marginRight:'10px'}}/> SYMFONY</p>
                <p><IconApiPlatform width={25} style={{marginRight:'10px'}}/> API PLATFORM</p>
            </div>
            <div className='col-skills fab'>
                <p><IconJS width={25} style={{marginRight:'10px'}}/> JAVASCRIPT</p>
                <p><IconReact width={25} style={{marginRight:'10px'}}/> REACT JS</p>
            </div>
            <div className='col-skills fab'>
                <p><img src={IconDbdiagram} alt="Make" width={25} style={{marginRight:'10px'}}/> DbDiagram</p>
                <p><IconSQL width={25} style={{marginRight:'10px'}}/> SQL</p>
            </div>
            <div className='col-skills fab'>
                <p><IconMysql width={25} style={{marginRight:'10px'}}/> MYSQL</p>
                <p><IconPostgres width={25} style={{marginRight:'10px'}}/> POSTGRESQL</p>
            </div>
            <div className='col-skills fab'>
                <p><IconDocker width={25} style={{marginRight:'10px'}}/> DOCKER</p>
                <p><IconLinux width={25} style={{marginRight:'10px'}}/> LINUX</p>
            </div>
            <div className='col-skills fab'>
                <p><IconMailjet width={25} style={{marginRight:'10px'}}/> MAILJET</p>
                <p><IconStripe width={25} style={{marginRight:'10px'}}/> STRIPE</p>
            </div>
            <div className='col-skills fab'>
                <p><img src={IconDust} alt="Dust" width={25} style={{marginRight:'10px'}}/> DUST</p>
                <p><img src={IconMake} alt="Make" width={25} style={{marginRight:'10px'}}/> MAKE</p>
            </div>
            <div className='col-skills fab'>
                <p><IconScaleway width={25} style={{marginRight:'10px'}}/> SCALEWAY</p>
                <p><IconSocket width={25} style={{marginRight:'10px'}}/> SOCKET IO</p>
            </div>
            <div className='col-skills fab'>
                <p><IconGithub width={30} style={{marginRight:'10px'}}/> GITHUB</p>
                <p><IconGitlab width={25} style={{marginRight:'10px'}}/> GITLAB</p>
            </div>
            <div className='col-skills fab'>
                <p><IconTalend width={25} style={{marginRight:'10px'}}/> TALEND</p>
                <p><Iconbootstrap width={25} style={{marginRight:'10px'}}/> BOOTSTRAP</p>
            </div>
            <div className='col-skills fab'>
                <p><IconHtml width={25} style={{marginRight:'10px'}}/> HTML</p>
                <p><IconCss width={25} style={{marginRight:'10px'}}/> CSS</p>
            </div>
        </>
    );

    return(
        <Container className="container skills-container">
            <div className="row align-items-center h-100">
                <div className="slider">
                    <div className="logos">
                        {skillsContent}
                        {skillsContent} 
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default Stack;